export const RANKING_SSE_QUERY_KEYS = {
  rankingProducao: ["ranking-dia-producao"],
  rankingEntrega: ["ranking-dia-entrega"],
  rankingFichaDiaria: ["ranking-dia-ficha"],
  rankingFichaSetores: ["ranking-ficha-setores"],
  dashboardProducao: [
    "producao-resumo",
    "producao-usuarios",
    "montagem-resumo",
    "montagem-usuarios",
    "bordeiro-resumo-dashboard",
    "ranking-montagem-fila",
    "fila-estatisticas",
  ],
  dashboardEntrega: ["entrega-resumo", "entrega-usuarios"],
  entregador: ["filaEntregas", "entregas-ativas-operacao"],
  roterista: ["aguardando-entrega", "rankingDiaEntrega", "entregas"],
  roteristaAutomatico: [
    "roteirizacao-lotes",
    "aguardando-entrega",
    "rankingDiaEntrega",
    "entregas",
  ],
  aguardandoEntregaPage: ["aguardando-entrega"],
  relatorioSaboresProducao: [
    "relatorio-sabores-producao",
    "relatorio-sabores-top10",
  ],
  estatisticasProducao: [
    "producao-resumo",
    "ranking",
    "usuarios-producao",
    "tamanhos",
    "bordas",
  ],
  estatisticasMontagem: ["montagem-resumo", "montagem-usuarios"],
  estatisticasEntrega: [
    "entrega-resumo",
    "ranking-entrega",
    "usuarios-entrega",
  ],
} as const;

/** Keys por tela: 1 evento SSE só refetcha o que a tela montada usa. */
export const FILA_INTEGRACAO_SSE_QUERY_KEYS = {
  filasIntegracao: ["filas-integracao"],
  sequenciaPedidos: ["sequencia-dia"],
  rodizio: ["rodizio-estado", "rodizio-sabores"],
  rodizioUrgencia: ["rodizio-urgencias", "rodizio-estado"],
  filaPorcoes: ["fila-porcoes"],
  filaBebidas: ["fila-bebidas"],
  rankingMontagem: ["ranking-dia-montagem"],
} as const;
